import React from 'react';
import useScrollReveal from '../../hooks/useScrollReveal';
import './ProductModules.css';

const MODULES = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <rect x="3" y="4" width="18" height="18"/><line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
    ),
    title: 'Appointment Management',
    desc: 'Online, walk-in, and tele-consultation booking with smart slot management.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
      </svg>
    ),
    title: 'Doctor Management',
    desc: 'Profiles, shifts, leaves, availability, and multi-branch doctor assignment.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    title: 'Patient Management',
    desc: 'Complete digital patient profiles with medical history and visit timelines.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
      </svg>
    ),
    title: 'Prescription Management',
    desc: 'Smart, voice-enabled prescriptions with templates and digital signatures.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <path d="M18.5 2h-13A2.5 2.5 0 0 0 3 4.5v1A2.5 2.5 0 0 0 5.5 8H6v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8h.5A2.5 2.5 0 0 0 21 5.5v-1A2.5 2.5 0 0 0 18.5 2z"/>
        <line x1="10" y1="12" x2="14" y2="12"/><line x1="12" y1="10" x2="12" y2="14"/>
      </svg>
    ),
    title: 'Pharmacy Management',
    desc: 'Inventory, dispensing, stock alerts, and prescription-linked billing.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <rect x="1" y="4" width="22" height="16"/><line x1="1" y1="10" x2="23" y2="10"/>
      </svg>
    ),
    title: 'Billing & Invoicing',
    desc: 'Instant invoices, GST-compliant billing, payment tracking, and receipts.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    ),
    title: 'Follow-up Management',
    desc: 'Scheduled reminders, missed follow-up tracking, and repeat consultation flows.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
      </svg>
    ),
    title: 'Document Storage',
    desc: 'Secure cloud storage for lab reports, scans, and medical documents.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
    title: 'Reports & Analytics',
    desc: 'Revenue, patient volume, doctor performance, and operational dashboards.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.07 4.93l-1.41 1.41M5.34 18.66l-1.41 1.41M3 12H1M23 12h-2M19.07 19.07l-1.41-1.41M5.34 5.34L3.93 3.93"/>
        <path d="M12 1v2M12 21v2"/>
      </svg>
    ),
    title: 'User Permissions',
    desc: 'Role-based access control for admin, doctor, nurse, receptionist, and pharmacy staff.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <polygon points="12 2 2 7 12 12 22 7 12 2"/>
        <polyline points="2 17 12 22 22 17"/>
        <polyline points="2 12 12 17 22 12"/>
      </svg>
    ),
    title: 'Multi-Branch Management',
    desc: 'Unified control over multiple clinics and hospital branches from one login.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
        <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
      </svg>
    ),
    title: 'Dashboard & Insights',
    desc: 'Real-time KPI overview with customizable widgets for every role and department.',
  },
];

const ProductModules = () => {
  const [ref, isVisible] = useScrollReveal(0.06);

  return (
    <section className="modules section section-light" id="modules" ref={ref}>
      <div className="container">
        <div className={`section-header centered reveal${isVisible ? ' visible' : ''}`}>
          <span className="section-tag">Product Suite</span>
          <h2 className="section-title">12 Integrated Modules</h2>
          <p className="section-subtitle centered">
            Every aspect of hospital operations covered in a single, deeply integrated platform. No third-party stitching required.
          </p>
        </div>

        <div className="modules-grid">
          {MODULES.map((mod, i) => (
            <div
              key={mod.title}
              className={`module-card reveal delay-${(i % 4) + 1}${isVisible ? ' visible' : ''}`}
            >
              <div className="module-card__icon">{mod.icon}</div>
              <div className="module-card__body">
                <h3 className="module-card__title">{mod.title}</h3>
                <p className="module-card__desc">{mod.desc}</p>
              </div>
              <div className="module-card__arrow">→</div>
            </div>
          ))}
        </div>

        <div className={`modules-cta reveal delay-4${isVisible ? ' visible' : ''}`}>
          <p className="modules-cta__text">
            All modules work together out of the box — no configuration required.
          </p>
          <button
  className="btn-primary"
  onClick={() => document.getElementById('modules')?.scrollIntoView({ behavior: 'smooth' })}
>
  Explore All Modules
</button>
        </div>
      </div>
    </section>
  );
};

export default ProductModules;
